// Merges partial launcher edits with defaults and saved siblings for optimistic updates.

import { type LauncherConfig, LauncherSchema } from '@vwam/config-contract'

export function mergeLauncherPatch(
  previous: LauncherConfig | undefined,
  patch: Partial<LauncherConfig>
): LauncherConfig {
  return { ...LauncherSchema.parse(previous ?? {}), ...patch }
}
